import script from "./saleSendDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./saleSendDetail.vue?vue&type=script&setup=true&lang=js"

import "./saleSendDetail.vue?vue&type=style&index=0&id=78a4df94&lang=less"

const __exports__ = script;

export default __exports__